import React from 'react'
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
import Main_Testmponial from './Main_Testmponial';
import Testmonial_page from './Testmonial_page';
function Review_Component() {
  return (
    <div>
      {/* ------------------Mobile view--------------- */}
      <div className='mt-5'>
        <div className='container d-sm-block d-md-none'>
        <MDBRow className="d-flex justify-content-center">
        <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
            <span className="display-5 review_component_text">Testimonials</span>
            <p className="pt-2 mobile_review_component_text_p">Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
        </MDBCol>
        </MDBRow>
        </div>

        {/* -------------------Desktop View------------------ */}
        <div className='container pt-2 d-none d-md-block'>
        <MDBRow className="d-flex justify-content-center">
        <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
            <span className="mb-4 display-4 review_component_text">Testimonials</span>
            <p className="py-4 mb-md-5 pb-md-0">Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
        </MDBCol>
        </MDBRow>
        </div>
        <div className='container '>
            <div className='testmonial_card_border'>
            <Testmonial_page/>  
            </div>
        </div>
        </div>
    </div>
  )
}

export default Review_Component
